<template>
  <div>
    <div class="form-check mr-1">
      <input
        class="form-check-input"
        type="radio"
        :name="name"
        :id="id"
        :value="value"
        :checked="checked"
        @change="$emit('update:modelValue', value)"
      />
      <label class="form-check-label" :for="id">
        {{ label }}
      </label>
    </div>
    <hint v-if="hint">
      {{ hint }}
    </hint>
  </div>
</template>
<script>
import Hint from "./Hint.vue";

export default {
  components: { Hint },
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      required: false,
    },
    value: {
      default: undefined,
    },
    modelValue: {
      default: undefined,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    checked: function () {
      return this.value === this.modelValue;
    },
  },
};
</script>
<style lang="scss" scoped>
.form-check {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  & > .form-check-label {
    white-space: nowrap;
    margin-left: 3px;
  }
}
</style>